"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPLUS_HOSTS = exports.INVARIANT_CHECK_HINTS = exports.INVARIANT_CHECK_LABELS = exports.INVARIANT_CHECK_CODES = exports.InvariantResultSchema = exports.InvariantViolationSchema = exports.INVARIANT_LABELS = exports.INVARIANT_IDS = void 0;
exports.invariantResult = invariantResult;
exports.isInvariantCheckCode = isInvariantCheckCode;
exports.isSplusHost = isSplusHost;
exports.defaultInvariantChecks = defaultInvariantChecks;
const zod_1 = require("zod");
/**
 * Site Invariant Check — PRS §5.4.
 *
 * Vì Copilot ghi thẳng vào file của s-solution, mọi thay đổi BẮT BUỘC đi qua bộ
 * kiểm tra này trước khi ghi. Vi phạm bất kỳ mục nào → chặn xuất bản.
 *
 * KHÔNG được thêm đường vòng bỏ qua kiểm tra này — kể cả cho admin, kể cả cho
 * Autopilot.
 */
exports.INVARIANT_IDS = [
    'cta-target',
    'contact-widget',
    'bilingual-pairs',
    'language-storage-key',
    'footer-standard',
    'hub-product-count',
];
exports.INVARIANT_LABELS = {
    'cta-target': 'Mọi CTA phải trỏ href="/contact"',
    'contact-widget': 'Đúng một thẻ contact-widget.js trước </body>',
    'bilingual-pairs': 'Mỗi node có data-vi phải có data-en tương ứng',
    'language-storage-key': 'localStorage key riêng theo slug',
    'footer-standard': 'Email và dòng bản quyền đúng chuẩn',
    'hub-product-count': 'Số đếm sản phẩm trên trang hub khớp thực tế',
};
exports.InvariantViolationSchema = zod_1.z.object({
    id: zod_1.z.enum(exports.INVARIANT_IDS),
    message: zod_1.z.string(),
    filePath: zod_1.z.string(),
    line: zod_1.z.number().int().positive().nullable(),
});
exports.InvariantResultSchema = zod_1.z.object({
    passed: zod_1.z.boolean(),
    violations: zod_1.z.array(exports.InvariantViolationSchema),
});
function invariantResult(violations) {
    return { passed: violations.length === 0, violations };
}
/* ────────────────────────────────────────────────────────────────────────────
 * Bật/tắt luật bất biến theo từng trang — spec SC-01
 * ──────────────────────────────────────────────────────────────────────────── */
/**
 * Mã của sáu luật bất biến, ĐÚNG như mã dùng trong `seo-checks.ts`.
 *
 * Vì sao không tái dùng `INVARIANT_IDS` ở trên: hai danh sách đó khác nhau về
 * cách viết (`bilingual-pairs` vs `bilingual`), và `INVARIANT_IDS` thuộc phần
 * Apply Engine (chặn xuất bản) đã ra khỏi phạm vi. Danh sách dưới đây là thứ
 * đi vào DB và đi vào bộ chấm điểm, nên phải khớp mã kiểm tra chứ không khớp
 * tài liệu cũ.
 */
exports.INVARIANT_CHECK_CODES = [
    'cta-target',
    'contact-widget',
    'bilingual',
    'lang-storage-key',
    'footer-standard',
    'hub-product-count',
];
exports.INVARIANT_CHECK_LABELS = {
    'cta-target': 'Mọi CTA trỏ href="/contact"',
    'contact-widget': 'Đúng một thẻ contact-widget.js trước </body>',
    'bilingual': 'Mỗi node có data-vi phải có data-en tương ứng',
    'lang-storage-key': 'localStorage key riêng theo slug',
    'footer-standard': 'Email và dòng bản quyền đúng chuẩn Splus',
    'hub-product-count': 'Số đếm sản phẩm trên trang hub khớp thực tế',
};
/** Mô tả một dòng cho hộp thoại thiết lập, để người dùng biết mình đang bật gì. */
exports.INVARIANT_CHECK_HINTS = {
    'cta-target': 'Site Splus quy ước mọi nút bấm dẫn về đúng một trang liên hệ chung.',
    'contact-widget': 'Widget hỗ trợ phải có mặt trên mọi trang sản phẩm của Splus.',
    'bilingual': 'Trang Splus song ngữ: mỗi đoạn tiếng Việt phải có đoạn tiếng Anh đi kèm.',
    'lang-storage-key': 'Mỗi trang nhớ lựa chọn ngôn ngữ bằng khoá riêng, không đè lên trang khác.',
    'footer-standard': 'Chân trang dùng đúng email và dòng bản quyền chuẩn của công ty.',
    'hub-product-count': 'Số sản phẩm ghi trên trang tổng phải khớp số trang thật sự có.',
};
function isInvariantCheckCode(code) {
    return exports.INVARIANT_CHECK_CODES.includes(code);
}
/**
 * Tên miền mà sáu luật trên thực sự áp dụng được.
 *
 * Đây là quy ước riêng của website Splus, không phải luật SEO chung — bật cho
 * trang của người khác là báo lỗi giả hàng loạt (spec SC-01 §1).
 */
exports.SPLUS_HOSTS = ['splus-software.com.vn'];
function isSplusHost(host) {
    const h = host.toLowerCase().replace(/\.$/, '').replace(/^www\./, '');
    return exports.SPLUS_HOSTS.some((s) => h === s || h.endsWith(`.${s}`));
}
/**
 * Lấy tên miền từ một URL http(s).
 *
 * Tự tách bằng biểu thức chính quy thay vì dùng `URL`: gói `shared` cố ý biên
 * dịch với `lib: ["ES2023"]`, không có DOM — nó là hợp đồng dữ liệu dùng chung,
 * không nên phụ thuộc global của nền tảng nào. Phần cần lấy ở đây chỉ là đoạn
 * host, và URL đi vào đây đều đã qua `assertSafeUrl` nên có dạng chuẩn.
 */
function hostOf(url) {
    const m = /^https?:\/\/(?:[^@/?#]*@)?([^/?#:]+)/i.exec(url.trim());
    return m?.[1] ?? null;
}
/**
 * Bộ luật mặc định cho một trang mới thêm: đủ sáu với trang Splus, rỗng với
 * mọi trang khác.
 *
 * URL hỏng thì trả rỗng — không đoán. Bật nhầm sáu luật riêng của Splus cho
 * trang người khác là báo lỗi giả hàng loạt, còn tắt nhầm thì chỉ là thiếu một
 * bảng tuân thủ mà người dùng bật lại được bằng một cú bấm.
 */
function defaultInvariantChecks(url) {
    const host = hostOf(url);
    return host && isSplusHost(host) ? [...exports.INVARIANT_CHECK_CODES] : [];
}
//# sourceMappingURL=invariant.js.map